(function () {
  'use strict';

  angular.module('app').component('teamMemberList', teamMemberList());

  function teamMemberList() {
    return {
      bindings: {
        items: '=',
        meta: '<',
        totalItems: '=',
        loadingItems: '<',
        onShowTeamMember: '&',
      },
      controller: TeamMemberListComponent,
      controllerAs: 'vm',
      templateUrl: './app/ajs/team-members/team-member-list/team-member-list.component.html',
    };
  }

  TeamMemberListComponent.$inject = ['UtilService', 'AbilityService', 'TeamMemberService'];

  function TeamMemberListComponent(UtilService, AbilityService, TeamMemberService) {
    var vm = this;

    vm.permissions = {
      canShow: AbilityService.can('show_teammember_accountadmin'),
      canUpdate: AbilityService.can('update_teammember_accountadmin'),
      canDestroy: AbilityService.can('destroy_teammember_accountadmin'),
    };

    vm.UtilService = new UtilService(vm);

    vm.filterCriteria = TeamMemberService.getFilterCriteria();

    // Methods
    vm.fetchResult = fetchResult;
    vm.refresh = refresh;
    vm.selectPage = selectPage;
    vm.onSort = onSort;
    vm.showItem = showItem;
    vm.deleteItem = deleteItem;
    vm.changeItemStatus = changeItemStatus;
    vm.onUpdateItems = onUpdateItems;

    // Initializers

    function fetchResult() {
      vm.loadingItems = true;
      TeamMemberService.getTeamMembers(vm.filterCriteria).then(function (data) {
        vm.items = data.items;
        vm.meta = data.meta;

        vm.totalItems = vm.meta.totalItems;

        vm.loadingItems = false;

        vm.showActions = false;
        vm.selectedAll = false;
      });
    }

    function refresh() {
      vm.filterCriteria = TeamMemberService.getFilterCriteria();
      fetchResult();
    }

    function selectPage() {
      vm.filterCriteria.offset = (vm.filterCriteria.page - 1) * vm.meta.itemsPerPage;
      fetchResult();
    }

    function onSort(sortedBy, sortDir) {
      vm.filterCriteria.page = 1;
      vm.filterCriteria.sortDir = sortDir;
      vm.filterCriteria.sortedBy = sortedBy;
      fetchResult();
    }

    function showItem(teamMember, mode) {
      if (!vm.permissions.canShow) {
        return;
      }

      vm.onShowTeamMember({ teamMember: teamMember, mode: mode });
    }

    function deleteItem(item) {
      TeamMemberService.deleteTeamMember(item, fetchResult);
    }

    function changeItemStatus(item) {
      TeamMemberService.changeTeamMemberStatus(item);
    }

    function onUpdateItems(action) {
      const successCallback = function () {
        vm.showActions = false;
        vm.selectedAll = false;

        if (action === 'destroy') fetchResult();
      };

      TeamMemberService.updateTeamMembers(action, vm.items, successCallback);
    }
  }
})();
